import { createAction } from '@reduxjs/toolkit';

export const resetUserProfile = createAction(
    'userProfile/resetUserProfile'
);